import { useContactManagementTranslation } from '../../../../ui/hooks/useContactManagementTranslation';
import { useFilterConfig } from '@juvare/common-data-table-ui/FiltersBar';
export function useGroupsFilterConfig() {
    const { t } = useContactManagementTranslation();
    return useFilterConfig((builder) => {
        builder.quickSearchFilter({
            dataPath: 'search',
            dataTest: 'toolbar-quick-search-input',
            label: t('common.search'),
            sx: { maxWidth: { xs: undefined, sm: 340 } },
        });
    }, [t]);
}
